import { BaseSystemFields, GeneralListRequest } from './common.model'
import { ProductModule } from './projects.model'

export interface RoleInfo {
	id?: string
	code: string
	display_name?: string
	inherited_role_ids?: string[]
	role_rights_list?: {
		id?: string
		project_id?: string
		module_rights_id?: string
		active?: boolean
	}[]
	active?: boolean
	project_id?: string
	org_ids?: string[]
	project_subs?: {
		item_type?: string
		item_id?: string
		active?: boolean //frontend for display
	}[]
	is_admin?: boolean
	role_profile_ids?: string[] //for create
	role_users?: {
		id?: string
		profile_id?: string
		active?: boolean
	}[]
	selectedInDialog?: string[] //for frontend

	permissionSettingItems?: ProductModule[]
	project_product_subs?: ProductModule[] //for edit
	base_system_field?: BaseSystemFields
	originalPermissions?: string[]
	permissions?: string[]

	// for frontend
	permissionsDiff?: {
		permission_code: string
		active: boolean
	}[]
}

export const InitRoleInfo: RoleInfo = {
	code: '',
	display_name: '',
	active: true,
	is_admin: false,
}

export interface ListRolesRequest extends GeneralListRequest {
	project_ids?: {
		operator: string
		value: string[]
	}
	role_ids?: {
		operator: string
		value: string[]
	}
	display_name?: {
		operator: string
		value: string
	}
	active?: {
		operator: '='
		value: boolean[]
	}
	is_deleted?: {
		operator: '='
		value: boolean[]
	}
	with_product_modules?: boolean
}

export interface RolePermission {
	role_id: string
	project_id: string
	is_admin: boolean
	permissions: string[]
}
